module.exports = __webpack_public_path__ + "static/media/service-customer-service.7124a813.jpg";